// Dashboard metrics and chart config (wire to API when available)
export const DATE_RANGE_OPTIONS = [
  { label: "Last 7 Days", value: "7" },
  { label: "Last 30 Days", value: "30" },
  { label: "Last 90 Days", value: "90" },
];

export const PERFORMANCE_METRIC_OPTIONS = [
  { label: "GMV", value: "gmv" },
  // { label: "Orders", value: "orders" },
  // { label: "Revenue", value: "revenue" },
];

export const STAT_METRICS = [
  {
    id: "totalGmv",
    label: "TOTAL GMV",
    value: "$38,912.44",
    trend: "+5.1%",
    trendDirection: "up",
    showMenu: false,
  },
  {
    id: "operatingCosts",
    label: "OPERATING COSTS",
    value: "$35,065.22",
    trend: "-1.8%",
    trendDirection: "down",
    showMenu: true,
  },
  {
    id: "yourRevenue",
    label: "YOUR REVENUE",
    value: "$3,847.22",
    trend: "+8.2%",
    trendDirection: "up",
    showMenu: true,
  },
  {
    id: "totalOrders",
    label: "TOTAL ORDERS",
    value: "484",
    trend: "+11.2%",
    trendDirection: "up",
    showMenu: false,
  },
  {
    id: "avgOrderValue",
    label: "AVG ORDER VALUE",
    value: "$80.39",
    trend: "+6.8%",
    trendDirection: "up",
    showMenu: false,
  },
];

export const formatPerformanceCurrencyK = (value) => {
  if (value >= 1000) {
    const amount = value / 1000;
    const formatted = Number.isInteger(amount) ? amount.toFixed(0) : amount.toFixed(1);
    return `$${formatted}k`;
  }
  return `$${value}`;
};

export const formatPerformanceCurrency = (value) => `$${value}`;

export const formatPerformanceOrders = (value) => `${value}`;

export const formatPerformanceAvgOrderValue = (value) => `$${value}`;

export const PERFORMANCE_CHART_DATA = [
  { date: "16 May", gmv: 4100, revenue: 400, operatingCosts: 3700, orders: 60, avgOrderValue: 68 },
  { date: "17 May", gmv: 4800, revenue: 500, operatingCosts: 4300, orders: 65, avgOrderValue: 73 },
  { date: "18 May", gmv: 5200, revenue: 520, operatingCosts: 4680, orders: 70, avgOrderValue: 74 },
  { date: "19 May", gmv: 5500, revenue: 550, operatingCosts: 4950, orders: 72, avgOrderValue: 76 },
  { date: "20 May", gmv: 5900, revenue: 590, operatingCosts: 5310, orders: 75, avgOrderValue: 78 },
  { date: "21 May", gmv: 6200, revenue: 620, operatingCosts: 5580, orders: 78, avgOrderValue: 79 },
  { date: "22 May", gmv: 6500, revenue: 650, operatingCosts: 5850, orders: 80, avgOrderValue: 81 },
];

export const URGENT_TASKS_COUNT = 5;
